<style scoped>
tr:nth-child(odd) {
  background: #f6f6f6;
}
</style>

<template>
  <v-layout row wrap>
    <v-layout align-center justify-space-between row fill-height>
      <v-flex xs5 sm6 pa-4>
        <v-text-field
          v-model="search"
          prepend-icon="search"
          label="Search"
          hide-details
        ></v-text-field>
      </v-flex>
      <v-flex xs4 md3 lg2 pa-4 justify-end>
        <customer-detail-item-add></customer-detail-item-add>
      </v-flex>
    </v-layout>
    <v-flex xs12>
      <v-alert
        v-if="alert"
        :value="!isLoading"
        :type="alert.type"
        v-html="alert.message"
      ></v-alert>
      <v-data-table
        :headers="headers"
        :loading="isLoading"
        :search="search"
        :items="customerDetailItems"
        :must-sort="true"
        class="elevation-0"
        :hide-actions="hideActions"
        :pagination.sync="pagination"
      >
        <template v-slot:items="{ item: user }">
          <tr>
            <td>{{ user.email }}</td>
            <td>
              <v-icon @click="onRemoveUser(user.id)">delete</v-icon>
            </td>
          </tr>
        </template>
        <template v-slot:no-data>
          <div v-if="isLoading" style="text-align: center;">Please wait</div>
        </template>
      </v-data-table>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapGetters } from "vuex";
import CustomerDetailItemAdd from "@/components/CustomerDetailItemAdd.vue";

const paginationRowsPerPage = -1;

export default {
  name: "CustomerDetailItems",
  components: {
    CustomerDetailItemAdd
  },
  data() {
    return {
      search: "",
      headers: [
        {
          text: "Email",
          value: "email"
        },
        {
          text: "Remove",
          sortable: false
        }
      ],
      pagination: {
        rowsPerPage: paginationRowsPerPage
      }
    };
  },
  computed: {
    ...mapGetters("admin", {
      customerDetailItems: "getCustomerDetailItems"
    }),
    alert() {
      return this.$store.state.admin.alert;
    },
    isLoading() {
      return this.$store.state.admin.loadingDetailItems;
    },
    hideActions() {
      return (
        !this.customerDetailItems ||
        this.customerDetailItems.length <= paginationRowsPerPage
      );
    },
    customerId() {
      return this.$route.params.customerId;
    }
  },
  methods: {
    onRemoveUser(userId) {
      this.$store.dispatch("admin/removeCustomerDetailItem", {
        customerId: this.customerId,
        itemId: userId
      });
    }
  },
  created() {
    this.$store.dispatch("admin/fetchCustomerDetailItems", {
      customerId: this.customerId
    });
  },
  watch: {
    alert(alert) {
      if (alert && alert.message) {
        setTimeout(() => {
          this.$store.commit("admin/setAlert", null);
        }, 3000);
      }
    }
  }
};
</script>
